import React, { useEffect, useState } from 'react'
import { components, constants, useServices, useTranslation } from 'cng-web-lib'
import ConveyanceMasterApiUrls from '../../../apiUrls/ConveyanceMasterApiUrls'
import NaCodeMaintenanceApiURLs from '../../../apiUrls/NaCodeMaintenanceApiUrls'
import CngField from 'src/components/cngcomponents/CngField'
import TinyChip from 'src/components/aciacehighway/TinyChip'
import TemplateSelectDialog from 'src/components/aciacehighway/TemplateSelectDialog'
import _ from 'lodash'
import { Box, Grid, Typography } from '@material-ui/core'
import { FileForUserGetPartyId } from 'src/common/FileForUserCommon'
import * as InputSource from 'src/common/InputSource'
import ACIHighwayManifestTranslationText from './../contexts/ACIHighwayManifestTranslationText'

const {
  table: { useFetchCodeMaintenanceLookup }
} = components

const {
  filter: { EQUAL, LIKE }
} = constants

function ConveyanceTemplateDialog(props) {
  const { open, ...otherProps } = props

  const [lookups, setLookups] = useState(null)
  const { fetchRecords } = useServices()
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()
  const aciHighwayManifestTranslationText = ACIHighwayManifestTranslationText()  

  useEffect(() => {
    if (open) {
      Promise.all([
        // Conveyance type
        fetchCodeMaintenanceLookup(
          constants.CodeMaintenanceType.CODE_MASTER,
          undefined,
          [
            {
              field: 'codeType',
              operator: EQUAL,
              value: 'ACE_HW_CONVEYANCE_TYPE'
            }
          ],
          undefined,
          'code'
        ),
        // Countries
        fetchCodeMaintenanceLookup(
          constants.CodeMaintenanceType.CODE_MASTER,
          undefined,
          [
            {
              field: 'codeType',
              operator: EQUAL,
              value: 'ACIHWY_MANIFEST_COUNTRY'
            }
          ],
          undefined,
          'code'
        ),
        // Country states
        fetchRecords.execute(
          NaCodeMaintenanceApiURLs.GET,
          {
            filters: [{ field: 'indicator', operator: EQUAL, value: 'ACE' }],
            customData: { codeMType: 'CountryStateCode' }
          },
          (res) => res.content
        )
      ]).then(([conveyanceType, countries, countryStates]) => {
        const states = Object.keys(countries).reduce((acc, countryCode) => {
          acc[countryCode] = countryStates.filter(
            (state) => state.code === countryCode
          )

          return acc
        }, {})

        setLookups({
          conveyanceType,
          countries,
          countryStates: states
        })
      })
    }
  }, [open])

  function getLookupValue(name, value) {
    if (!lookups) return value

    return lookups[name] && lookups[name][value] ? lookups[name][value] : value
  }

  function getCountryStateLabel(country, state) {
    if (!lookups || !country || !state) return state

    // Check if country code exists in the lookup
    if (Object.keys(lookups.countries).includes(country)) {
      const result = lookups.countryStates[country].find(
        (countryState) => countryState.intlcode === state
      )

      return result ? result.descriptionEn : state
    } else {
      return state
    }
  }

  const columns = [
    {
      title: `${aciHighwayManifestTranslationText.aceId} & ${aciHighwayManifestTranslationText.conveyanceId}`,
      render: (template) => (
        <Box>
          <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
            {template.aceId}
          </Typography>
          <Typography color='textSecondary' style={{ fontSize: 12, lineHeight: 1.2 }}>
            {template.conveyanceID}
          </Typography>
        </Box>
      )
    },
    {
      title: `${aciHighwayManifestTranslationText.conveyanceType} & ${aciHighwayManifestTranslationText.conveyanceNo}`,
      render: (template) => (
        <>
          <Typography component='span' variant='inherit'>
            {getLookupValue('conveyanceType', template.conveyanceType)}
            <TinyChip label={template.conveyanceType} variant='outlined' />
          </Typography>
          {' , '}
          {template.conveyanceNo}
        </>
      )
    }
  ]

  const extraFields = [
    {
      label: aciHighwayManifestTranslationText.licensePlate,
      gridProps: { sm: 12, md: 12 },
      render: (template) =>
        template.licensePlates.length > 0 && (
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {template.licensePlates.map((licensePlate) => (
                <Grid item key={licensePlate.id} xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4}>
                      <CngField label={aciHighwayManifestTranslationText.licensePlateNum}>
                        {licensePlate.licensePlateNo}
                      </CngField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CngField label={aciHighwayManifestTranslationText.countryRegistration}>
                        {getLookupValue(
                          'countries',
                          licensePlate.countryofRegistration
                        )}
                      </CngField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <CngField label={aciHighwayManifestTranslationText.provinceStateRegionRegistration}>
                        {getCountryStateLabel(
                          licensePlate.countryofRegistration,
                          licensePlate.state
                        )}
                      </CngField>
                    </Grid>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
        )
    }
  ]

  return (
    <TemplateSelectDialog
      columns={columns}
      extraFields={extraFields}
      defaultSorts={[{ field: 'conveyanceID', direction: 'ASC' }]}
      fetch={{ url: ConveyanceMasterApiUrls.GET }}
      fetchFilters={[
        { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() },
        { field: 'inputSource', operator: EQUAL, value: InputSource.ACI_HWY_MANIFEST }
      ]}
      open={open}
      search={{ field: 'inputValue', operator: LIKE }}
      title={aciHighwayManifestTranslationText.conveyanceTemplateTitle}
      {...otherProps}
    />
  )
}

export default ConveyanceTemplateDialog
